<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title> Add Invoice</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">

                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <b>PRN No</b><v-icon color="error">*</v-icon>
                        <v-text-field v-model="invOrder_Details.prn_no" label="PRN No" class="mt-4" hide-details
                            @change="onPrnNoChange" outlined dense required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="this.invVendorList.length > 0">
                        <b>Vendor</b>
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense required v-model="invOrder_Details.inv_vendor"
                            item-value="id" :items="invVendorList" item-text="company_name" class="mt-4" label="Vendor"
                            outlined />

                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="mt-10" v-if="this.invVendorList.length > 0">
                        <v-btn class="mt-3" color="info" @click="getReport()" :loading="loader">Fetch
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">

                    </v-col>
                </v-row>
                <br><br>
                <v-simple-table class="mytable" style="width: 60%; margin: auto;"
                    v-if="this.student_Details.length > 0">
                    <thead>
                        <th>PRN</th>
                        <th>Student Name</th>
                        <th>Standard</th>
                        <th>Division</th>
                    </thead>
                    <tbody>
                        <tr v-for="item in student_Details" :key="item.lid">
                            <td>{{ item.prn }}</td>
                            <td>{{ item.first_name_last_name }}</td>
                            <td>{{ item.standard }}</td>
                            <td>{{ item.division }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <br><br>
                <v-simple-table class="mytable" style="width: 80%; margin: auto;" v-if="this.invOrderDetail.length > 0">
                    <thead>

                        <th>Order No</th>
                        <th>Order Date</th>
                        <th>Invoice No</th>
                        <th>Invoice Date</th>
                        <th>View Invoice</th>
                        <th>Order Details</th>
                        <th>Delivery Instruction</th>
                        <th>Add Item</th>

                    </thead>
                    <tbody>
                        <tr v-for="item in invOrderDetail" :key="item.invOrder_id">
                            <td>{{ item.order_id }}</td>
                            <td>{{ item.order_date }}</td>
                            <td>{{ item.invoice_no || '--' }}</td>
                            <td>{{ item.invoice_date || '--' }}</td>
                            <td>
                                <v-icon v-if="item.invoice_id" @click="showInvoice(item)" color="green"
                                    title="View Invoice">
                                    mdi-eye
                                </v-icon>
                                <span v-else>--</span>
                            </td>
                            <td>
                                <v-icon v-if="item.invOrder_id" @click="getOrderDetaisFromInvorder(item.invOrder_id)"
                                    title="View Orders" color="green">
                                    mdi-eye
                                </v-icon>
                                <span v-else>--</span>
                            </td>
                            <td>
                                <v-icon v-if="item.delivery_instructions" @click="showdeliveryinstructions(item)"
                                    title="View Delivery Instructions" color="green">
                                    mdi-eye
                                </v-icon>
                                <span v-else>--</span>
                            </td>
                            <td>
                                <v-btn icon size="22" :title="'Click here to Add'"
                                    v-if="item.is_Quantity_less_than_Order_item_quantity">
                                    <v-icon class="add-plus-icon" color="indigo"
                                        @click="opendialogforadditem(item)">mdi-plus-circle</v-icon>
                                </v-btn>
                                <span v-else>--</span>
                            </td>


                        </tr>
                    </tbody>
                </v-simple-table>

                <v-dialog v-model="dialog" fullscreen persistent>
                    <v-card class="elevation-12">

                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>Select Items</v-toolbar-title>
                            <v-spacer />
                            <v-btn icon size="40" :title="'Close'">
                                <v-icon @click="dialog = false">mdi-close-circle</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3" md="3" class="pt-3">

                                <b>Delivery Option</b> <v-icon color="error">*</v-icon>
                                <v-autocomplete color="#0F2027" dense required class="mt-4"
                                    v-model="invOrder_Details.deliveryoption_id" item-value="id" filled readonly
                                    :items="deliveryOptionList" item-text="name" label="Delivery Option" outlined />

                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-3">
                                <b>Shipping Address</b> <v-icon color="error">*</v-icon>
                                <v-textarea v-model="invOrder_Details.shipping_address" label="Shipping Address" filled
                                    readonly hide-details outlined dense required class="mt-4"></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pt-3">
                                <v-icon color="error"></v-icon>
                                <v-checkbox v-model="laddress" color="success" filled readonly
                                    :label="`Billing Address Same As Shipping Address`" @change="copyAddress()"
                                    class="mt-4"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-3" v-if="this.laddress == true">
                                <b>Billing Address</b> <v-icon color="error">*</v-icon>
                                <v-textarea v-model="invOrder_Details.billing_address" label="Billing Address" filled
                                    readonly hide-details outlined dense required class="mt-4"></v-textarea>
                            </v-col>

                        </v-row>


                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3" md="3" class="pt-3">
                                <b>Item Category</b> <v-icon color="error">*</v-icon>
                                <v-autocomplete color="#0F2027" dense required
                                    v-model="invOrder_Details.itemCategory_id" item-value="id" :items="itemCategoryList"
                                    item-text="name" label="Item Category" outlined class="mt-4"
                                    @change="handleItemCategoryChange(invOrder_Details.itemCategory_id)" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-3"
                                v-if="invOrder_Details.itemCategory_id && itemList.length > 0">

                                <b>Item</b> <v-icon color="error">*</v-icon>
                                <v-autocomplete color="#0F2027" dense required v-model="invOrder_Details.vendor_item_id"
                                    item-value="id" :items="itemList" item-text="name" label="Item" outlined
                                    @change="getSizeLableAndSizelableType(invOrder_Details.vendor_item_id)"
                                    class="mt-4" />
                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-3 "
                                v-if="invOrder_Details.itemCategory_id && itemList.length > 0">
                                <b>Quantity</b>
                                <v-icon color="error">*</v-icon>
                                <v-text-field v-model="invOrder_Details.quantity" label="Quantity" hide-details outlined
                                    dense required class="mt-4"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3" md="3" class="pt-3 ">

                            </v-col>


                            <v-col cols="12" sm="3" md="3" class="pt-3" v-if="showSizeLabel">
                                <b>Size Label Type</b> <v-icon color="error"></v-icon>
                                <v-autocomplete color="#0F2027" dense class="mt-4" required filled readonly
                                    v-model="invOrder_Details.sizeLabelType_id" item-value="id"
                                    :items="sizeLabelTypesList" item-text="name" label="Size Label Type" outlined />
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-3" v-if="showSizeLabel">
                                <b>Size Label</b><v-icon color="error"></v-icon>
                                <v-autocomplete color="#0F2027" dense class="mt-4" required filled readonly
                                    v-model="invOrder_Details.sizeLabel_id" item-value="id" :items="sizeLabelsList"
                                    item-text="name" label="Size Label" outlined />
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="mt-10 pt-3"
                                v-if="itemList.length > 0 && invOrder_Details.itemCategory_id">
                                <v-btn class="info" @click="checkItemQuantity()" :loading="loader">
                                    Add Item
                                </v-btn>
                                <!-- addToTempInvoiceDetails -->
                            </v-col>
                            <!-- 
                            <v-col cols="12" sm="2" md="2" class="pt-3 ">

                            </v-col> -->




                        </v-row>
                        <br><br>
                        <v-simple-table class="mytable" style="width: 94%; margin: auto;"
                            v-if="add_temp_invoice_details_list.length">
                            <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>Item Name</th>
                                    <th>Item Code</th>
                                    <th>ISBN</th>
                                    <th>Item Category</th>
                                    <th>Item Description</th>
                                    <th>Size Label Type</th>
                                    <th>Size Label</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Net Amount</th>
                                    <th>Tax Rate</th>
                                    <th>Tax Amount</th>
                                    <th>Total Amount</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in add_temp_invoice_details_list" :key="index">
                                    <td class="text-center" style="display: flex; align-items: center; gap: 8px;">
                                        <span>{{ index + 1 }}</span>
                                        <v-btn icon color="red" small @click="removeItemFromInvoiceList(index)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>{{ item.item_name }}</td>
                                    <td>{{ item.item_code }}</td>
                                    <td>{{ item.isbn }}</td>
                                    <td>{{ item.item_category }}</td>
                                    <td>{{ item.item_description }}</td>
                                    <td>{{ item.size_label_type }}</td>
                                    <td>{{ item.size_label }}</td>
                                    <td>{{ item.price }}</td>
                                    <td>{{ item.quantity }}</td>
                                    <td>{{ item.net_amount }}</td>
                                    <td>{{ item.tax }}%</td>
                                    <td>{{ item.tax_amount }}</td>
                                    <td>{{ item.total }}</td>

                                </tr>
                                <!-- Total, Delivery, and Grand Total Rows -->
                                <tr>
                                    <td colspan="12" class="text-right"><b>TOTAL</b></td>
                                    <td>{{ totalTaxAmount }}</td>
                                    <td>{{ TotalAmount }}</td>
                                </tr>
                                <tr>
                                    <td colspan="13" class="text-right"><b>DELIVERY CHARGES</b></td>
                                    <td>{{ totalDeliveryCharges }}</td>
                                </tr>
                                <tr>
                                    <td colspan="13" class="text-right"><b>GRAND TOTAL</b></td>
                                    <td><b>{{ grandTotalAmount }}</b></td>
                                </tr>
                                <tr>
                                    <td colspan="14" class="text-left"><b>Amount in words:</b> {{
                                        grandTotalAmountInWords }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-row justify="center">
                            <v-col cols="12" sm="2" md="2">

                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-8"
                                v-if="this.add_temp_invoice_details_list.length > 0">
                                <v-btn class="" color="success" @click="addItem" :loading="loader">
                                    Generate Invoice
                                </v-btn>

                            </v-col>
                        </v-row>


                    </v-card>
                </v-dialog>


            </v-card>



            <v-dialog v-model="orderItemsDialog" max-width="800px">
                <v-card class="box">
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Order Items</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-data-table :headers="orderItemsHeaders" :items="selectedOrderItems" dense
                            class="elevation-1">
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="orderItemsDialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogdeliveryinstructions" max-width="800px">
                <v-card class="box">
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Delivery Instructions</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text>
                        <Strong>{{ deliveryinstructions }}</Strong>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="dialogdeliveryinstructions = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>




        </v-container>

    </div>

</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({

        loader: false,
        orderItemsDialog: false,
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        snackbar_msg: "",
        search: "",
        basepath: null,
        laddress: true,
        dialog: false,
        color: "",
        deliveryinstructions: "",
        // company_name: "",
        //  vendor_signature_file: "",
        snackbar: false,
        overlay: false,
        showSizeLabel: false,
        dialogdeliveryinstructions: false,
        invVendorList: [],
        student_Details: [],
        deliveryOptionList: [],
        itemList: [],
        selectedOrderItems: [],
        invoice_details_item_list: [],
        add_temp_invoice_details_list: [],
        itemCategoryList: [],
        sizeLabelTypesList: [],
        sizeLabelsList: [],
        invOrderDetail: [],
        item_check_List: [],

        invOrder_Details: {
            invOrder_id: null,
            order_id: null,
            order_date: null,
            invoice_no: null,
            prn_no: null,
            invoice_date: null,
            inv_vendor: null,
            deliveryoption_id: null,
            shipping_address: null,
            billing_address: null,
            quantity: null,
            itemCategory_id: null,
            sizeLabelType_id: null,
            sizeLabel_id: null,
            vendor_item_id: null,


        },


        orderItemsHeaders: [
            { text: 'Item Name', value: 'itemName' },
            { text: 'Quantity', value: 'quantity' },
            { text: 'Base Price', value: 'base_price' },
            { text: 'Tax', value: 'tax' },
            { text: 'Total Price', value: 'price' },
            { text: 'Delivery Status', value: 'deliverystatus' },
        ],


    }),
    computed: {
        totalDeliveryCharges() {
            return this.add_temp_invoice_details_list.reduce(
                (sum, item) => sum + (item.delivery_charges || 0),
                0
            );
        },
        totalTaxAmount() {
            return this.add_temp_invoice_details_list.reduce(
                (sum, item) => sum + (item.tax_amount || 0),
                0
            );
        },
        TotalAmount() {
            return this.add_temp_invoice_details_list.reduce(
                (sum, item) => sum + (item.total || 0),
                0
            );
        },
        grandTotalAmount() {
            return this.TotalAmount + this.totalDeliveryCharges;
        },
        grandTotalAmountInWords() {
            // Implement or use a helper function for number-to-words conversion
            return this.numberToWords(this.TotalAmount);
        },
    },

    methods: {
        removeItemFromInvoiceList(index) {
            this.add_temp_invoice_details_list.splice(index, 1);
            this.showSnackbar("green", "Item removed successfully!");
        },
        getOrderDetaisFromInvorder(order_id) {
           
            this.selectedOrderItems = [];
            const data = {

                order_id: order_id,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getOrderDetaisFromInvorder", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.orderItemsDialog = true;
                        this.selectedOrderItems = res.data.view_order_list;

                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.orderItemsDialog = false;
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.orderItemsDialog = false;
                    }
                    this.overlay = false;
                })
               
        },
        getItemsCategoryFromInvorder(order_id) {
           
            this.itemCategoryList = [];
            const data = {

                order_id: order_id,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getItemsCategoryFromInvorder", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.itemCategoryList = res.data.itemCategoryList;

                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        onPrnNoChange() {
            // Handle the change event here
            console.log('PRN No changed to:', this.invOrder_Details.prn_no);
            this.invVendorList = [];
            const data = {

                prn_no: this.invOrder_Details.prn_no,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getVendorFromLearner", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.invVendorList = res.data.invVendorList;
                       
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        getSizeLableAndSizelableType(id) {

            const selecteditem = this.itemList.find((item) => item.id === id);

            if (selecteditem) {
                this.invOrder_Details.sizeLabel_id = selecteditem.sizelabel_id;
                this.invOrder_Details.sizeLabelType_id = selecteditem.sizeLabelType_id;
            } else {
                this.invOrder_Details.sizeLabel_id = null;
                this.invOrder_Details.sizeLabelType_id = null;
            }
        },


        checkItemQuantity() {
            if (this.invOrder_Details.itemCategory_id == null || this.invOrder_Details.itemCategory_id == '') {
                this.showSnackbar("red", "Please Select Item Category..!");
                return;
            }

            if (this.invOrder_Details.vendor_item_id === undefined || this.invOrder_Details.vendor_item_id === 'undefined' || this.invOrder_Details.vendor_item_id === '' || this.invOrder_Details.vendor_item_id === '') {
                this.showSnackbar("red", "Please Select Item ..!");
                return;
            }
            if (this.invOrder_Details.quantity == null || this.invOrder_Details.quantity == '') {
                this.showSnackbar("red", "Please Enter Quantity..!");
                return;
            }
            this.item_check_List = [];
            const data = {
                vendor_item_id: this.invOrder_Details.vendor_item_id,
                quantity: this.invOrder_Details.quantity,
                invOrder_id: this.invOrder_Details.invOrder_id,
                itemCategory_id: this.invOrder_Details.itemCategory_id,
                   
            };
            this.overlay = true;
            axios
                .post("/EduStore/checkItemQuantity", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.item_check_List = res.data.item_check_List;
                        this.addToTempInvoiceDetails(this.item_check_List);
                        // this.showSnackbar("green", "All items validated successfully!");

                    } else if (res.data.flag === "PARTIAL") {

                        const invalidMessages = res.data.invalidItems
                            .map(item => item.message)
                            .join("\n");
                        this.showSnackbar("red", `\n${invalidMessages}`);
                    } else {
                        const errorMessage = res.data.msg || "An unknown error occurred.";
                        this.showSnackbar("red", errorMessage);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("red", "An error occurred while processing your request.");
                    console.error(error);
                })
                .finally(() => {
                    this.overlay = false;
                });

        },

        addItem() {
            const formData = {
                invOrder_id: this.invOrder_Details.invOrder_id,
                add_temp_invoice_details_list: this.add_temp_invoice_details_list,
            };
            this.overlay = true;
            axios
                .post("/EduStore/saveAddInvoice", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.invoice_details_item_list = res.data.invoice_details_item_list;
                        this.add_temp_invoice_details_list = [];
                        this.student_Details = [];
                        this.invOrderDetail = [];
                        this.dialog = false;

                        this.showSnackbar("green", "Invoice Generate successfully...!");
                        // this.company_name = res.data.company_name;
                        // this.vendor_signature_file = res.data.vendor_signature_file;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.msg);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.msg);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        addToTempInvoiceDetails(validItemIds) {
            if (!validItemIds || validItemIds.length === 0) {
                this.showSnackbar("red", "No valid items to add.");
                return;
            }

            validItemIds.forEach(itemId => {
                // Find the item in itemList by ID
                const item = this.itemList.find(item => item.id === itemId);

                if (!item) {
                    console.warn(`Item with ID ${itemId} not found in itemList.`);
                    return; // Skip this iteration if item is not found
                }

                // Check if the item is already in add_temp_invoice_details_list
                const existingItem = this.add_temp_invoice_details_list.find(
                    tempItem => tempItem.id === item.id
                );

                if (existingItem) {
                    this.showSnackbar("red", `Item ${item.name} is already added to the list.`);
                    return; // This stops the loop for this item only
                }

                // Calculate quantities and amounts
                const quantity = this.invOrder_Details.quantity;
                const netAmount = item.price * quantity;
                const tax = item.tax;
                const tax_amount = netAmount * tax / 100;
                const totalAmount = netAmount + tax_amount;

                // Add the item to the temporary invoice list
                this.add_temp_invoice_details_list.push({
                    id: item.id,
                    item_name: item.name,
                    item_code: item.item_code,
                    isbn: item.isbn,
                    item_category: item.itemcategory,
                    item_description: item.description,
                    size_label_type: item.sizelabelType,
                    size_label: item.sizelabel,
                    price: item.price,
                    quantity: quantity,
                    tax: tax,
                    net_amount: netAmount,
                    tax_amount: tax_amount,
                    total: totalAmount,
                    delivery_charges: item.delivery_charges || 0,
                });

                this.showSnackbar("green", `Item "${item.name}" added successfully!`);
            });

            // // Reset input fields
            // this.invOrder_Details.vendor_item_id = null;
            // this.invOrder_Details.quantity = 1;
        },

        numberToWords(num) {
            if (num === 0) return "zero";

            const belowTwenty = [
                "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
                "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen",
                "Eighteen", "Nineteen",
            ];
            const tens = [
                "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
            ];
            const thousandPowers = ["", "Thousand", "Million", "Billion"];

            function convertChunk(num) {
                let words = "";

                if (num >= 100) {
                    words += belowTwenty[Math.floor(num / 100) - 1] + " Hundred ";
                    num %= 100;
                }
                if (num >= 20) {
                    words += tens[Math.floor(num / 10)] + " ";
                    num %= 10;
                }
                if (num > 0) {
                    words += belowTwenty[num - 1] + " ";
                }

                return words.trim();
            }

            let wordResult = "";
            let chunkIndex = 0;

            while (num > 0) {
                if (num % 1000 !== 0) {
                    wordResult =
                        convertChunk(num % 1000) + " " + thousandPowers[chunkIndex] + " " + wordResult;
                }
                num = Math.floor(num / 1000);
                chunkIndex++;
            }

            return wordResult.trim();
        },
        copyAddress() {
            if (this.laddress) {

              //  this.invOrder_Details.billing_address = this.invOrder_Details.shipping_address;

            }
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        handleItemCategoryChange(itemCategoryId) {
            const selectedCategory = this.itemCategoryList.find(
                (category) => category.id === itemCategoryId
            );
            this.showSizeLabel = selectedCategory.is_size_applicable || false;

            // if (!this.showSizeLabel) {
            //     this.sizeLabelsList = []; // Clear size labels if not applicable
            //     this.sizeLabel = null;
            // }

            // Fetch items based on selected category
            this.getsizelable(itemCategoryId);
        },
        getsizelable(itemCategory_id) {
            this.itemList = [];
            const data = {

                itemCategory_id: itemCategory_id,
                invOrder_id: this.invOrder_Details.invOrder_id,
            };
            this.overlay = true;
            axios
                .post("/EduStore/getItemFromOrderItemCategory", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.itemList = res.data.itemList;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    //  this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },

        opendialogforadditem(item) {

            this.dialog = true;
            this.laddress = true;
            this.invOrder_Details = {
                invOrder_id: item.invOrder_id || null,
                order_no: item.order_id || null,
                order_date: item.order_date || null,
                invoice_no: item.invoice_no || null,
                invoice_date: item.invoice_date || null,
                shipping_address: item.shipping_address || null,
                billing_address: item.billing_address || null,

                deliveryoption_id: item.deliveryoption_id || null,
                prn_no: this.invOrder_Details.prn_no,
                inv_vendor: this.invOrder_Details.inv_vendor,
            };
            
            this.getItemsCategoryFromInvorder(item.invOrder_id);
        },

        showInvoice(item) {
            localStorage.setItem("invoice_id", item.invoice_id);
            let routeData = this.$router.resolve({ name: "view-invoice-edustore" });
            window.open(routeData.href, "_blank");
        },
        showdeliveryinstructions(item) {
            this.deliveryinstructions = item.delivery_instructions
            this.dialogdeliveryinstructions = true;
        },
        getReport() {
            if (this.invOrder_Details.prn_no == null || this.invOrder_Details.prn_no == '') {
                this.showSnackbar("#b71c1c", "Please Enter Prn No...!");
                return;
            }
            if (this.invOrder_Details.inv_vendor == null || this.invOrder_Details.inv_vendor == '') {
                this.showSnackbar("#b71c1c", "Please Select Vendor...!");
                return;
            }
            this.loader = true;
            this.student_Details = [];
            const data = {
                prn_no: this.invOrder_Details.prn_no,
                inv_vendor: this.invOrder_Details.inv_vendor,

            };
            axios
                .post("/EduStore/getAddInvoiceStudentDetails", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.student_Details = res.data.student_Details;
                        // Populate the invOrder_Details object
                        this.invOrderDetail = res.data.invOrder_Details; // Assuming the first object in the list

                        this.loader = false;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.loader = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.loader = false;
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/EduStore/getAddInvoice")
                .then((res) => {
                    if (res.data.msg == "200") {
                      
                        this.deliveryOptionList = res.data.deliveryOptionList;
                        this.sizeLabelTypesList = res.data.sizeLabelTypesList;
                        this.sizeLabelsList = res.data.sizeLabelsList;


                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },


        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {

    },
};
</script>
<style scoped>




tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .button1 {
        border: 2px solid white !important;
        color: #1196cf;
        margin: 0.5rem !important;
        background-color: lightgray !important;
    }

    .button1:hover {
        color: white !important;
        background: #ffc200 !important;
        background: #0f2027;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right,
                #2c5364,
                #203a43,
                #0f2027);
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}

.sign {
    padding-left: 855px !important;
}



/* Table Header Styling */



/* Table Rows */


</style>
